module.exports = __webpack_public_path__ + "img/carbs-dairy.f8f594e8.png";